import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { CalendarArrowDown, CalendarArrowUp } from "lucide-react";

type Props = {
    disabled?: boolean;
    onClick: () => void;
    sortByAscending?: boolean;
    ascendingLabel?: string;
    descendingLabel?: string;
}

export const SortOrderButton = ({
    disabled = false,
    onClick,
    sortByAscending = false,
    ascendingLabel = "Sort Ascending",
    descendingLabel = "Sort Descending",
  }: Props) => {
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    disabled={disabled}
                    size='action'
                    variant="secondary"
                    onClick={onClick}
                >
                    {sortByAscending ? (
                        <CalendarArrowDown size={16} />
                    ) : (
                        <CalendarArrowUp size={16} />
                    )}
                </Button>
            </TooltipTrigger>
            <TooltipContent>
                {sortByAscending ? ascendingLabel : descendingLabel} 
            </TooltipContent>
        </Tooltip>
    )
}
